'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _lodash = require('lodash');

var _chemist = require('chemist');

var _FormInput = require('../FormInput');

var _deliveryRatesField = require('./deliveryRatesField');

var _deliveryRatesField2 = _interopRequireDefault(_deliveryRatesField);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryForm = (_dec = (0, _chemist.configurable)(), _dec2 = (0, _reactI18next.translate)(), _dec3 = (0, _reactCssModules2.default)(_style2.default), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(DeliveryForm, _React$Component);

  function DeliveryForm() {
    (0, _classCallCheck3.default)(this, DeliveryForm);
    return (0, _possibleConstructorReturn3.default)(this, (DeliveryForm.__proto__ || (0, _getPrototypeOf2.default)(DeliveryForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(DeliveryForm, [{
    key: 'shippingRates',
    value: function shippingRates(index) {
      if (this.props.config.store.pickupLocations && this.props.config.store.pickupLocations.enabled) {
        return this.props.order.shipments[index].shippingRates;
      }

      return this.props.order.shipments[index].shippingRates.filter(function (rate) {
        return !rate.name.match(/^Click & Collect/);
      });
    }
  }, {
    key: 'selectedRate',
    value: function selectedRate(index) {
      if (this.props.order.shipAddress.firstname === 'Collection Point') {
        return this.props.order.shipments[index].shippingRates.find(function (rate) {
          return rate.name === 'Click & Collect (UK)';
        });
      }

      return this.props.order.shipments[index].shippingRates.find(function (rate) {
        return rate.name !== 'Click & Collect (UK)';
      });
    }
  }, {
    key: 'splitShipments',
    value: function splitShipments() {
      return this.props.order.shipments.length > 1;
    }
  }, {
    key: 'shipmentTitle',
    value: function shipmentTitle(shipment) {
      var t = this.props.t;


      if (!this.splitShipments()) return false;
      return _react2.default.createElement(
        _FormInput.Legend,
        { className: 't-title--tertiary' },
        t('spree.shipment'),
        ' ',
        shipment.number
      );
    }
  }, {
    key: 'renderShipmentLineItems',
    value: function renderShipmentLineItems(shipment) {
      if (!this.splitShipments()) return false;

      var variantIds = shipment.manifest.map(function (item) {
        return item.variantId;
      });
      var isVariantMatch = function isVariantMatch(variant) {
        return variantIds.indexOf(variant.variantId) !== -1;
      };
      var lineItems = this.props.order.lineItems.filter(isVariantMatch);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'ul',
          { styleName: 'shipments-list' },
          lineItems.map(function (lineItem) {
            return _react2.default.createElement(
              'li',
              { key: (0, _lodash.uniqueId)() },
              lineItem.variant.name,
              ' ',
              _react2.default.createElement(
                'span',
                null,
                '|'
              ),
              ' ',
              lineItem.variant.optionsText
            );
          })
        )
      );
    }
  }, {
    key: 'renderDeliveryNotification',
    value: function renderDeliveryNotification() {
      if (this.props.config.store.code === 'eesbru') {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            '\xA1Gracias por comprar en Bruguer!'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Te informamos de que los pedidos que contengan muestras (\u201CTesters\u201D) de color se enviar\xE1n a trav\xE9s de Correos.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Si has comprado m\xE1s de 4 muestras, es posible que las recibas en varias entregas.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Puedes seguir el estado de tu env\xEDo en ',
            _react2.default.createElement(
              'a',
              {
                href: 'https://www.correos.es/es/es/herramientas/localizador/envios',
                style: {
                  color: '#333',
                  'text-decoration': 'underline',
                  margin: '0px',
                  padding: '0px',
                  'font-size': '14px'
                },
                rel: 'noopener noreferrer',
                target: '_blank'
              },
              'la web de Correos sigue tu env\xEDo'
            ),
            '.'
          )
        );
      }

      return '';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          _props$config = _props.config,
          store = _props$config.store,
          theme = _props$config.theme;

      var heading = theme === 'woodcare' ? t('woodcare.delivery_options') : t('delivery_options');
      var subtext = theme === 'woodcare' ? t('woodcare.delivery_subtext') : t('delivery_subtext');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _FormInput.Fieldset,
          null,
          _react2.default.createElement(
            _FormInput.Legend,
            null,
            heading
          ),
          this.props.order.shipments.map(function (shipment, index) {
            return _react2.default.createElement(
              'div',
              { key: index, styleName: 'shipment' },
              _this2.shipmentTitle(shipment),
              _this2.renderShipmentLineItems(shipment),
              _react2.default.createElement(_deliveryRatesField2.default, {
                shipmentId: shipment.id,
                index: index,
                key: shipment.id,
                selectedRate: _this2.selectedRate(index),
                deliveryRates: _this2.shippingRates(index),
                currency: _this2.props.order.currency
              }),
              store.showDeliveryOptionSubtext && _react2.default.createElement(
                'p',
                { styleName: 'shipping-rate-subtext' },
                subtext
              )
            );
          })
        ),
        this.renderDeliveryNotification()
      );
    }
  }]);
  return DeliveryForm;
}(_react2.default.Component), _class2.propTypes = {
  order: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object
}, _temp)) || _class) || _class) || _class);
exports.default = DeliveryForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/DeliveryForm/index.js
// module id = 2458
// module chunks = 0